module.exports = __webpack_public_path__ + "img/10.14f31275.svg";